/* eslint-disable no-useless-computed-key */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useState } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import { useParams } from "react-router-dom";
import ProductIcon from "../../../../../assets/images/icon_menus/ProductIcon.json";
import { useDispatch, useSelector } from "react-redux";
import customStyles from "../../../../../assets/styles/customStyles";
import younoteAdminActions from "../../../../YounoteAdmin/Product/redux/actions";
import { MyProductView } from "./MyProductView";

const CreateWithCatalogue = (props) => {
    const { history } = props;
    const dispatch = useDispatch();
    const { catalogueId } = useParams();
    const { catalogueDetails, categoryDetails } = useSelector(state => state.younoteAdminProductReducer);
    const [customCatalogue, setCustomCatalogue] = useState('');

    useEffect(() => {
        loadTasks();
    }, []);

    useEffect(() => {
        if (catalogueDetails && catalogueDetails?.length > 0) {
            setCustomCatalogue(catalogueDetails[0])
        }
    }, [catalogueDetails]);

    const loadTasks = useCallback(() => {
        dispatch({
            type: younoteAdminActions.CATALOGUE_DETAILS_START,
            filter: { where: { ["and"]: [{ id: catalogueId }] } }
        });
        dispatch({
            type: younoteAdminActions.BRAND_DETAILS_START, url: `/product-categories/${catalogueId}/unique-brands`
        });
        loadChilderTasks();
    });

    const loadChilderTasks = () => {
        dispatch({
            type: younoteAdminActions.CATEGORY_DETAILS_START,
            url: 'product-categories',
            filter: {
                where: { ["and"]: [{ catalogueId: catalogueId }] }
            }
        });

        dispatch({
            type: younoteAdminActions.PRODUCT_DETAILS_START,
            filter: {
                order: 'productName asc',
                where: { ["and"]: [{ catalogueId: catalogueId }, { status: 'ACTIVE' }] }
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader
                {...props}
                img={ProductIcon}
                title={'Product'}
                links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'My Products', 'link': '' }]} />
            <MyProductView
                classes={classes}
                history={history}
                loadChilderTasks={() => loadChilderTasks()}
                customCatalogue={customCatalogue}
                categoryDetails={categoryDetails ? categoryDetails : []} />
        </React.Fragment>
    );
}

export default CreateWithCatalogue;